import { IPartialReducer } from "../../../../core/core-redux/reduxTypes";
import { Wms3dLayersState } from "../../wms3dLayers.reducer";

export const wms3dLayerLoadingPartialReducer: IPartialReducer<Wms3dLayersState> = () => {
    return {
        loading: true,
    };
};
